<template>
    <div class="small row align-items-center" :class="className">
        <div class="col-auto text-center">
            <i class="fe fe-repeat"></i>
        </div>
        <a id="repeats" class="col-auto" href="#" v-on:click.prevent.stop>
            <div v-if="data.repeat">
                <div class="row">
                    <div class="text-muted col">{{$t('Repeats')}}:</div>
                    <span class="col-auto">{{ label }}</span>
                </div>

                <div v-if="duration" class="row">
                    <div class="col text-muted">{{$t('Ends')}}:</div>
                    <span class="col-auto">{{ duration }}</span>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col text-muted">{{$t('Repeat')}}</div>
                <div class="col-auto">{{$t('Do not repeat')}}</div>
            </div>
        </a>
        <b-popover
            style="border:1px solid red; max-width:600px; width:600px; border:1px solid red;"
            triggers="click"
            target="repeats"
            ref="popover"
            placement="bottom"
        >
            <div class="form-group">
                <label>{{$t('Frequency')}}</label>
                <b-form-select v-model.trim="data.repeat" :options="options"></b-form-select>
            </div>
            <div class="form-group" v-if="data.repeat">
                <label>{{$t('Ends')}}</label>
                <b-form-select v-model.trim="data.duration" :options="durations"></b-form-select>
            </div>
            <div class="form-group" v-if="data.duration == 'date'">
                <date-picker label="Date" :calendarOptions="calendarOptions" v-model="data.endsAt"></date-picker>
            </div>

            <div class="row justify-content-between">
                <div class="col">
                    <b-button variant="white" @click="close">
                        <i class="fe fe-x"></i>
                    </b-button>
                </div>
                <div class="col">
                    <b-button class="ml-2" @click="set" variant="primary">
                        <i class="fe fe-check"></i>
                    </b-button>
                </div>
            </div>
        </b-popover>
    </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'
export default {
    props: ['value', 'className'],
    components: {
        DatePicker,
    },
    computed: {
        label() {
            const value = this.options.find(i => i.value === this.data.repeat);
            if (value) {
                return value.text;
            }
        },
        duration() {
            if (this.data.duration !== 'date') {
                const value = this.durations.find(i => i.value === this.data.duration);
                if (value) {
                    return value.text;
                }
            } else {
                const value = this.$moment(this.data.endsAt);
                return value.format('dddd, MMMM Do YYYY');
            }

        }
    },
    created() {
        this.data = this.value || {};
        // this.data.endsAt = this.$moment(this.data.endsAt);
    },
    data() {
        return {
            data: {},
            calendarOptions: {
                wrap: true,
                minDate: new Date(),
            },
            durations: [
                { text: this.$t('After {value} times', { value: 2 }), value: 2 },
                { text: this.$t('After {value} times', { value: 3 }), value: 3 },
                { text: this.$t('After {value} times', { value: 4 }), value: 4 },
                { text: this.$t('After {value} times', { value: 5 }), value: 5 },
                { text: this.$t('After {value} times', { value: 6 }), value: 6 },
                { text: this.$t('After {value} times', { value: 7 }), value: 7 },
                { text: this.$t('After {value} times', { value: 8 }), value: 8 },
                { text: this.$t('After {value} times', { value: 9 }), value: 9 },
                { text: this.$t('After {value} times', { value: 10 }), value: 10 },
                { text: this.$t('After {value} times', { value: 11 }), value: 11 },
                { text: this.$t('After {value} times', { value: 12 }), value: 12 },
                { text: this.$t('After {value} times', { value: 13 }), value: 13 },
                { text: this.$t('After {value} times', { value: 14 }), value: 14 },
                { text: this.$t('After {value} times', { value: 15 }), value: 15 },
                { text: this.$t('After {value} times', { value: 20 }), value: 20 },
                { text: this.$t('After {value} times', { value: 25 }), value: 25 },
                { text: this.$t('After {value} times', { value: 30 }), value: 30 },
                { text: this.$t('Specific date'), value: 'date' },
                { text: this.$t('Ongoing'), value: 'ongoing' },
            ],
            options: [
                { text: this.$t('Do not repeat'), value: null, },
                { text: this.$t('Daily'), value: '1 day', },
                { text: this.$t('Every {value} days', { value: 2 }), value: '2 days' },
                { text: this.$t('Every {value} days', { value: 3 }), value: '3 days' },
                { text: this.$t('Every {value} days', { value: 4 }), value: '4 days' },
                { text: this.$t('Every 5 days'), value: '5 days' },
                { text: this.$t('Every {value} days', { value: 6 }), value: '6 days' },
                { text: this.$t('Weekly'), value: '1 week' },
                { text: this.$t('Every {value} weeks', { value: 2 }), value: '2 weeks' },
                { text: this.$t('Every {value} weeks', { value: 3 }), value: '3 weeks' },
                { text: this.$t('Every {value} weeks', { value: 4 }), value: '4 weeks' },
                { text: this.$t('Monthly'), value: '1 month' },
                { text: this.$t('Every 2 months', { value: 2 }), value: '2 months' },
                { text: this.$t('Every 3 months', { value: 3 }), value: '3 months' },
                { text: this.$t('Every 4 months', { value: 4 }), value: '4 months' },
                { text: this.$t('Every {value} months', { value: 5 }), value: '5 months' },
                { text: this.$t('Every {value} months', { value: 6 }), value: '6 months' },
                { text: this.$t('Every {value} months', { value: 7 }), value: '7 months' },
                { text: this.$t('Every {value} months', { value: 8 }), value: '8 months' },
                { text: this.$t('Every {value} months', { value: 9 }), value: '9 months' },
                { text: this.$t('Every {value} months', { value: 10 }), value: '10 months' },
                { text: this.$t('Every {value} months', { value: 11 }), value: '11 months' },
                { text: this.$t('Yearly'), value: '1 year' },
            ]
        }
    },
    methods: {
        close() {
            this.$refs.popover.$emit('close')
        },
        set() {
            this.$refs.popover.$emit('close');
            this.$emit('input', this.data);

        }
    }
}
</script>

<style>

</style>
